import { useState } from 'react';
import { InformationTransparency, TransparencyClass } from '../../../../api/apiTypes';
import Paginator from '../../../../utils/Paginator';
import { Link } from 'react-router-dom';
import { routesMap } from '../../../../routes/AppRoutes';
import ReportStatusBadge from '../../../../utils/ReportStatusBadge';
import { Eye } from 'lucide-react';

type ContainerListaDriverPageProps = {
  intermediari: InformationTransparency[];
  driverRoute: string | undefined;
  reportId: string;
  idReport: string;
  driverId: string;
};

const transparencyClasses: { key: TransparencyClass; label: string; description: string }[] = [
  {
    key: "strategy_with_fee_breakdown",
    label: "Fee breakdown",
    description: "Strategia pubblicata con suddivisione delle commissioni tra Banca trasmettitrice e Intermediario negoziatore"
  },
  {
    key: "strategy_with_total_costs",
    label: "Costi totali",
    description: "Strategia pubblicata con i costi complessivi senza suddivisione tra Banca trasmettitrice e Intermediario"
  },
  {
    key: "strategy_without_costs",
    label: "Senza costi",
    description: "Strategia pubblicata senza alcuna indicazione di costi"
  },
  {
    key: "no_strategy",
    label: "Nessuna strategia",
    description: "Nessuna strategia pubblicata"
  }
];

const ContainerTrasparenzaInformativa = ({
  intermediari,
  driverRoute,
  reportId,
  idReport,
  driverId,
}: ContainerListaDriverPageProps) => {

  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState<number>(() => {
    const saved = localStorage.getItem("trasparenzaPage");
    return saved ? parseInt(saved, 10) : 1; // Corretto: base 6 a 10
  });

  const totalPages = Math.ceil(intermediari.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    localStorage.setItem("trasparenzaPage", page.toString());
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = intermediari.slice(startIndex, startIndex + itemsPerPage);

  // Definizione della griglia corretta con 10 colonne
  const gridTemplate = "grid-cols-[2fr_1.5fr_repeat(4,1fr)_1fr_1fr_1fr_1fr]";

  return (
    <div className="">
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">

        {/* Header tabella */}
        <div className={`grid ${gridTemplate} gap-x-2 p-4 border-b border-gray-100 bg-gray-50 font-semibold text-[#1B365D] text-xs`}>
          <div className="flex items-center">Intermediario</div>
          <div className="flex justify-center items-center">Ultimo aggiornamento</div>
          {transparencyClasses.map(({ label }) => (
            <div key={label} className="flex justify-center items-center">{label}</div>
          ))}
          <div className="flex justify-center items-center">Score</div>
          <div className="flex justify-center items-center">Stato</div>
          <div className="flex justify-center items-center">Validazione</div>
          <div className="flex justify-center items-center">Azioni</div>
        </div>

        {/* Body tabella */}
        {currentItems.map((intermediario) => {
  const { id, name, value, status, validation } = intermediario;
  return (
    <div
      key={id}
      className={`grid ${gridTemplate} gap-x-2 p-4 hover:bg-gray-50/50 transition duration-150 ease-in-out text-gray-800 text-xs items-center hover:bg-gray-50/50 transition duration-150 ease-in-out`}
    >
      <div className="flex items-center font-medium">{name}</div>
      {/* Puo' mancare: l'estrazione la cerca nel documento e, se non la trova,
          lascia null. Una cella vuota sembrerebbe un dato non caricato. */}
      <div className="flex justify-center items-center">
        {value.doc_update_date ?? (
          <span className="text-gray-400" title="Data non rilevata nel documento">
            –
          </span>
        )}
      </div>
      {transparencyClasses.map(({ key }) => (
        <div
          key={key}
          className="flex justify-center items-center font-semibold"
        >
          {value.transparency_class === key ? "V" : "-"}
        </div>
      ))}
      <div className="flex justify-center items-center">{value.score.total_score}</div>
      <div className="flex justify-center items-center">
        <ReportStatusBadge stato={status} />
      </div>
      <div className="flex justify-center items-center">
        <ReportStatusBadge stato={validation} />
      </div>
      <div className="flex justify-center items-center">
        <Link
          to={routesMap.VISUALIZZA_INTERMEDIARIO(reportId, driverRoute ?? "", intermediario.name)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-[#1B365D] text-white hover:bg-[#142a4a] transition-colors"
          state={{ idReport, driverId, key: intermediario.id }}
        >
          <Eye className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
})}


        {/* Paginazione */}
        {totalPages > 1 && (
          <div className="p-4">
            <Paginator
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}

        {/* Legenda */}
        <div className="mt-6 p-4 border-t border-gray-100 text-sm text-[#1B365D]">
          <strong>Legenda:</strong>
          <ul className="list-disc ml-6 mt-2">
            {transparencyClasses.map(({ label, description }) => (
              <li key={label}><strong>{label}:</strong> {description}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContainerTrasparenzaInformativa;